export const LOCKED_UNTIL = 'lockedUntil'; // время разблокировки повторного запроса кода
